import { MobileFooterWrapper } from "./style";

interface IMobileFooterProps extends React.HTMLAttributes<HTMLDivElement> {}

function MobileFooter({ children }: IMobileFooterProps) {
  return <MobileFooterWrapper>{children}</MobileFooterWrapper>;
}

export default MobileFooter;
